export const isLoading = state => state?.loading?.active
